<template>
  <Loader v-if="loader" />

  <prime-accordion :multiple="true" :activeIndex="[0]" >

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
          <span>Dettagli</span>&nbsp;<span>{{ data.item.info.code }}</span>
      </template>

      <div v-if="data.item.id" class="formgrid grid">

        <div class="field col-12 md:col-4">
          <label for="name">Nome</label>
          <prime-input-text id="name" v-model="data.item.info.name" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="f1">Fascia 1</label>
          <prime-input-text id="f1" v-model="data.item.info.f1" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="pcv">PCV</label>
          <prime-input-text id="pcv" v-model="data.item.info.pcv" type="text" :disabled="true" class="inputfield w-full"  />
        </div>

        <div class="field col-12 md:col-4">
          <label for="code">Code</label>
          <prime-input-text id="code" v-model="data.item.info.code" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="f2">Fascia 2</label>
          <prime-input-text id="f2" v-model="data.item.info.f2" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="pcv_var">PCV Var</label>
          <prime-input-text id="pcv_var" v-model="data.item.info.pcv_var" type="text" :disabled="true" class="inputfield w-full"  />
        </div>

        <div class="field col-12 md:col-4">
          <label for="data_inizio">Data Inizio</label>
          <prime-calendar id="data_inizio" v-model="dataInizio" :showIcon="true" dateFormat="dd/mm/yy" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="f3">Fascia 3</label>
          <prime-input-text id="f3" v-model="data.item.info.f3" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="pa">PA</label>
          <prime-input-text id="pa" v-model="data.item.info.pa" type="text" :disabled="true" class="inputfield w-full"  />
        </div>

        <div class="field col-12 md:col-4">
          <label for="data_fine">Data Fine</label>
          <prime-calendar id="data_fine" v-model="dataFine" :showIcon="true" dateFormat="dd/mm/yy" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="p">P</label>
          <prime-input-text id="p" v-model="data.item.info.p" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="sbilanciamento">Sbilanciamento</label>
          <prime-input-text id="sbilanciamento" v-model="data.item.info.sbilanciamento" type="text" :disabled="true" class="inputfield w-full"  />
        </div>

        <div class="field col-12 md:col-4">
          <label for="cod_type_offerta">Tipologia Offerta</label>
          <prime-dropdown id="cod_type_offerta" v-model="data.item.info.cod_type_offerta" :options="data.tipiOfferta" optionLabel="name" optionValue="id" placeholder="Seleziona..." :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="op">OP</label>
          <prime-input-text id="op" v-model="data.item.info.op" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4"></div>

        <div class="field col-12 md:col-4">
          <label for="cod_type_tariffazione">Tipologia Tariffa</label>
          <prime-dropdown id="cod_type_tariffazione" v-model="data.item.info.cod_type_tariffazione" :options="data.tipiTariffazione" optionLabel="name" optionValue="id" placeholder="Seleziona..." :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4">
          <label for="m">M</label>
          <prime-input-text id="m" v-model="data.item.info.m" type="text" :disabled="true" class="inputfield w-full"  />
        </div>
        <div class="field col-12 md:col-4 flex justify-content-end">

          <prime-button 
            icon="pi pi-file" 
            class="p-button-rounded p-button-info m-2" 
            @click="scaricaXmlOfferta"
            v-tooltip.left="'Scarica XML offerta'"
          />

          <prime-button 
            icon="pi pi-file-pdf" 
            class="p-button-rounded p-button-success m-2" 
            @click="openDialogDownloadPdf"
            v-tooltip.left="'Scarica pdf offerta'"
          />

          <prime-button 
            icon="pi pi-clone" 
            class="p-button-rounded p-button-secondary p-button-outlined m-2" 
            @click="cloneCte"
            v-tooltip.left="'Duplica offerta'"
          />

        </div>

      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Provvigioni agente">
      <div v-if="data.item.id">
        
        <div class="formgrid grid">

          <div class="field col-12">
            <div class="wrap-align-center">
              <label class="justify-content-center text-blue-500">Gettone</label>
            </div>
          </div>

          <div class="field col-12 md:col-4">
            <div class="wrap-align-center">
              <label for="gettone1" class="justify-content-center">Tranche 1</label>
              <prime-input-number 
                id="gettone1"
                v-model="data.item.provvigioni_agente.gettone1"
                mode="currency" 
                currency="EUR" 
                locale="it-IT" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />

              <prime-dropdown 
                id="giorni_gettone1" 
                v-model="data.item.provvigioni_agente.giorni_gettone1" 
                :options="data.listaMensilita" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="Seleziona..." 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <div class="wrap-align-center">
              <label for="gettone2" class="justify-content-center">Tranche 2</label>
              <prime-input-number 
                id="gettone2"
                v-model="data.item.provvigioni_agente.gettone2"
                mode="currency" 
                currency="EUR" 
                locale="it-IT" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />              

              <prime-dropdown 
                id="giorni_gettone2" 
                v-model="data.item.provvigioni_agente.giorni_gettone2" 
                :options="data.listaMensilita" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="Seleziona..." 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <div class="wrap-align-center">
              <label for="gettone3" class="justify-content-center">Tranche 3</label>
              <prime-input-number 
                id="gettone3"
                v-model="data.item.provvigioni_agente.gettone3"
                mode="currency" 
                currency="EUR" 
                locale="it-IT" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />

              <prime-dropdown 
                id="giorni_gettone3" 
                v-model="data.item.provvigioni_agente.giorni_gettone3" 
                :options="data.listaMensilita" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="Seleziona..." 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>

          <div class="field col-12">
            <div class="wrap-align-center">
              <label for="totale_gettone" class="justify-content-center">Totale Gettone</label>
              <div>
                <span id="totale_gettone" class="justify-content-center">
                  {{ currencyFormatter.format(data.item.provvigioni_agente.giorni_gettone1 + data.item.provvigioni_agente.giorni_gettone2 + data.item.provvigioni_agente.giorni_gettone3) }}
                </span>
              </div>
            </div>
          </div>

          <div class="field col-12">
            <hr>
          </div>

          <div class="field col-12">
            <div class="wrap-align-center">
              <label class="justify-content-center text-blue-500">Gettone Consumo</label>
            </div>
          </div>

          <div class="field col-4 col-offset-4">
            <div class="wrap-align-center">
              <label for="gettone_consumo" class="justify-content-center">€/Mwh o €/Smc</label>
              <prime-input-number 
                id="gettone_consumo"
                v-model="data.item.provvigioni_agente.gettone_consumo" 
                locale="it-IT" 
                mode="decimal"
                :minFractionDigits="2" 
                :maxFractionDigits="4" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />
            </div>
          </div>

          <div class="field col-12">
            <hr>
          </div>

          <div class="field col-12">
            <div class="wrap-align-center">
              <label class="justify-content-center text-blue-500">Ricorrente</label>
            </div>
          </div>

          <div class="field col-4 col-offset-4">
            <div class="wrap-align-center">
              <label for="gettone_ricorrente_punto" class="justify-content-center">€/POD - €/PDR</label>
              <prime-input-number 
                id="gettone_ricorrente_punto"
                v-model="data.item.provvigioni_agente.gettone_ricorrente_punto" 
                locale="it-IT" 
                mode="decimal"
                :minFractionDigits="2" 
                :maxFractionDigits="2" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />
            </div>
          </div>

          <div class="field col-4 col-offset-4">
            <div class="wrap-align-center">
              <label for="gettone_ricorrente_consumo" class="justify-content-center">€/Mwh - €/Smc</label>
              <prime-input-number 
                id="gettone_ricorrente_consumo"
                v-model="data.item.provvigioni_agente.gettone_ricorrente_consumo" 
                locale="it-IT" 
                mode="decimal"
                :minFractionDigits="2" 
                :maxFractionDigits="4" 
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield text-center w-full" 
              />
            </div>
          </div>

          <div class="field col-12">
            <hr>
          </div>

        </div>

        <div class="grid p-jc-end">
          <div 
            class="col-12 text-right"
            v-if="!provvigioniAgenteIsInEdit"
          >
            <prime-button 
              icon="pi pi-pencil" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onEditProvvigioniAgente"
            />
          </div>

          <div 
            class="col-12 text-right"
            v-if="provvigioniAgenteIsInEdit"
          >
            <prime-button 
              icon="pi pi-times" 
              class="p-button-rounded p-button-danger mr-2" 
              @click="onAbortProvvigioniAgenteEdit"
            />
            <prime-button 
              icon="pi pi-check" 
              class="p-button-rounded p-button-success mr-2" 
              @click="onUpdateProvvigioniAgente"
            />
          </div>
        </div>
        
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contratti">
      <div v-if="data.item.id">
        <prime-data-table 
          :paginator="true" 
          :rows="10"
          :rowsPerPageOptions="[10,25,50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          
          :value="data.item.contratti.vendite" 
          
          responsiveLayout="scroll"
        >
          <prime-column field="data_inizio" header="Data Inizio" :sortable="true" >
            <template #body="{data}">
              {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine" :sortable="true" >
            <template #body="{data}">
              {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
            </template>
          </prime-column>
          <prime-column field="periodo" header="Periodo" ></prime-column>
          <prime-column field="pagamento" header="Metodo Pagamento" ></prime-column>
          <prime-column field="tipologia" header="Tipologia" ></prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

  </prime-accordion>

  <Dialog v-model:visible="visibleDownloadPdf" modal :style="{ width: '30%' }">
    <div class="flex flex-column align-items-center mb-5">
      <label class="font-semibold m-2">Seleziona Agente per CoBranding</label>
      <Dropdown v-model="selectedAgente" :options="agentiForOfferta" optionLabel="name" optionValue="id" :style="{ width: '75%' }" filter/>        
    </div>
    <div class="flex justify-content-center gap-2">
      <Button label="Scarica Pdf offerta" class="p-button-success p-button-raised p-button-rounded" @click="showPdf()"/>
    </div>
  </Dialog>
</template>

<script>
import OfferteService from '@/services/ask-management/offerte-service'
import UtilityService from '@/services/ask-management/utility-service'

import PrimeButton from 'primevue/button'
import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeCalendar from 'primevue/calendar'
import PrimeDataTable from 'primevue/datatable'
import PrimeColumn from 'primevue/column'
import PrimeDropdown from 'primevue/dropdown'
import PrimeInputText from 'primevue/inputtext'
import PrimeInputNumber from 'primevue/inputnumber'
import {wizard} from '@/config/sites'
import Loader from '@/components/Loader.vue'


import moment from 'moment'

export default {
  name: 'ViewAskListiniDetail',
  components: {
    PrimeButton,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeCalendar,
    PrimeDropdown,
    PrimeInputText,
    PrimeInputNumber,
    PrimeDataTable,
    PrimeColumn,
    Loader,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      route: {
        params: null
      },

      provvigioniAgenteIsInEdit: false,
      oldProvvigioniAgente: null,

      data: {
        tipiTariffazione: [],
        tipiOfferta: [],
        listaMensilita: Array.from(Array(13).keys()).map(el => `${el} mesi`).map( (el, key) => { return { value: key, label: el} } ),
        item: {},
      },
      visibleDownloadPdf: false,
      selectedAgente: null,
      agentiForOfferta: [],
      loader: false,
      withoutAgent: false
    }
  },

  created(){
    this.route.params = this.$route.params
    // console.log('ViewAskListiniDetail route params',this.route.params)

    this.offerteService = new OfferteService(this.$http, this.$eventBus)
    this.getDettaglioOfferta(this.route.params.id)

    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getTipiTariffazione()
    this.getTipiOfferta()
    this.getAgentiForOfferta()
  },

  methods: {
    getDettaglioOfferta(id){
      // this.table.loading = true
      this.offerteService.getDettaglioOfferta(id).then((res) => {
        this.data.item = res.item
        // title page browser
        document.title = 'info' in this.data.item ? ('code' in this.data.item.info ? document.title+" - "+  this.data.item.info.code : document.title) : document.title
        // this.table.loading = false
      })
    },

    getTipiTariffazione(){
      this.utilityService.getTipiTariffazione().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data.tipiTariffazione = res.items
      })
    },

    getTipiOfferta(){
      this.utilityService.getTipiOfferta().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data.tipiOfferta = res.items
      })
    },

    //////////////////////////////

    onEditProvvigioniAgente(){
      this.oldProvvigioniAgente = JSON.stringify(this.data.item.provvigioni_agente)

      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit
    },

    onAbortProvvigioniAgenteEdit(){
      this.data.item.provvigioni_agente = JSON.parse(this.oldProvvigioniAgente)

      this.oldProvvigioniAgente = null
      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit
    },

    onUpdateProvvigioniAgente(){
      const allowed = [
        'gettone1', 'giorni_gettone1',
        'gettone2', 'giorni_gettone2',
        'gettone3', 'giorni_gettone3',
        'gettone_consumo', 'gettone_ricorrente_punto', 'gettone_ricorrente_consumo',
      ]
      
      const provvigioniAgente = Object.keys(this.data.item.provvigioni_agente)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.data.item.provvigioni_agente[key]
        };
      }, {})
      
      if( this.oldProvvigioniAgente != JSON.stringify(this.data.item.provvigioni_agente) ) {
        this.offerteService.updateProvvigioniAgente(this.data.item.id, provvigioniAgente).then((res) => {
          // console.log('UPDATED', res)
          if(res.success){
            this.data.item.provvigioni_agente = res.item
          }
        })
      }

      this.oldProvvigioniAgente = null
      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit
    },

    scaricaXmlOfferta() {
      this.loader = true

      this.offerteService.scaricaXmlOfferta(this.data.item.id)
        .finally(() => {
          this.loader = false
        })
    },

    showPdf(){
      this.loader = true
      this.closeDialogDownloadPdf()      
      this.utilityService.showPdfOfferta(this.data.item.id, this.selectedAgente)
      .finally(()=>{
        this.loader = false
      })
    },

    cloneCte(){
      window.open(`${wizard.url}/offerte/${this.route.params.id}`, '_blank')
    },
    openDialogDownloadPdf(){
      this.selectedAgente = null
      this.visibleDownloadPdf = true
    },
    closeDialogDownloadPdf(){
      this.visibleDownloadPdf = false
    },
    getAgentiForOfferta(){
      this.offerteService.getAgentiForOfferta(this.route.params.id)
      .then((res) => {
        this.agentiForOfferta = res.item        
      })
    }
  },

  computed: {
    dataInizio: {
      get: function() {
        return (this.data.item.info.data_inizio !== null && this.data.item.info.data_inizio !== '')? moment(this.data.item.info.data_inizio).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data.item.info.data_inizio = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data.item.info.data_inizio = null
        }
      }
    },

    dataFine: {
      get: function() {
        return (this.data.item.info.data_fine !== null && this.data.item.info.data_fine !== '')? moment(this.data.item.info.data_fine).toDate(): null
      },
      set: function(value) {
        if(value instanceof Date && !isNaN(value.valueOf())){
          this.data.item.info.data_fine = moment(value).format('YYYY-MM-DD')
        }

        if( (value === null) || (value === '')){
          this.data.item.info.data_fine = null
        }
      }
    }
  },
}
</script>

<style>
.wrap-align-center{
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;

}

.wrap-align-center .p-inputnumber-input {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: center;
}
</style>
